import React from 'react';

function KeyIcon(props) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.4916 2.51666C13.025 0.0583293 9.02498 0.0583293 6.57498 2.51666C4.84998 4.225 4.33331 6.68333 4.99998 8.85L1.08331 12.7667C0.808313 13.05 0.616646 13.6083 0.674979 14.0083L0.924979 15.825C1.01665 16.425 1.57498 16.9917 2.17498 17.075L3.99165 17.325C4.39165 17.3833 4.94998 17.2 5.23331 16.9083L5.91665 16.225C6.08331 16.0667 6.08331 15.8 5.91665 15.6333L4.29998 14.0167C4.05831 13.775 4.05831 13.375 4.29998 13.1333C4.54165 12.8917 4.94165 12.8917 5.18331 13.1333L6.80831 14.7583C6.96665 14.9167 7.23331 14.9167 7.39164 14.7583L9.15831 13C11.3166 13.675 13.775 13.15 15.4916 11.4417C17.95 8.98333 17.95 4.975 15.4916 2.51666ZM11.0833 9C9.93331 9 8.99998 8.06666 8.99998 6.91666C8.99998 5.76666 9.93331 4.83333 11.0833 4.83333C12.2333 4.83333 13.1666 5.76666 13.1666 6.91666C13.1666 8.06666 12.2333 9 11.0833 9Z"
                fill="#C2C6D4"/>
        </svg>

    );
}

export default KeyIcon;
